/* eslint-disable @typescript-eslint/no-explicit-any */
import type { UseMutationResult } from '@tanstack/react-query';
import { Button, Group, Stack, Text } from '@mantine/core';
import { openContextModal, type ContextModalProps } from '@mantine/modals';
import { toast } from '../toast';

type DeleteModalProps<TData = unknown, TError = Error, TVariables = string, TContext = unknown> = {
  onDelete: () => UseMutationResult<TData, TError, TVariables, TContext>;
  desc?: string;
  title?: string;
  id: string;
  errorMessage?: string;
  successMessage?: string;
};

export const DeleteModal = ({
  context,
  id: modalId,
  innerProps,
}: ContextModalProps<DeleteModalProps>) => {
  const { onDelete, desc, id, errorMessage, successMessage } = innerProps;
  const { isPending, mutateAsync } = onDelete();
  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      toast.success({ title: 'Berhasil', message: successMessage });
      context.closeModal(modalId);
    } catch (e: any) {
      toast.error({
        title: 'Gagal',
        message: e?.response?.data?.message ?? errorMessage,
      });
    }
  };

  return (
    <Stack>
      <Text size="sm">{desc}</Text>
      <Group mt="md" ml="auto">
        <Button variant="default" onClick={() => context.closeModal(modalId)}>
          Batal
        </Button>
        <Button color="red" loading={isPending} onClick={handleDelete}>
          Ya
        </Button>
      </Group>
    </Stack>
  );
};

export const openDeleteModal = ({
  onDelete,
  id,
  desc,
  title,
  errorMessage = 'Gagal Menghapus Data',
  successMessage = 'Data Telah Terhapus',
}: DeleteModalProps) =>
  openContextModal({
    modal: 'delete',
    title: title ?? 'Yakin ingin menghapus?',
    centered: true,
    innerProps: {
      id,
      desc: desc ?? 'Data yang dihapus tidak dapat dikembalikan. Lanjutkan?',
      onDelete,
      errorMessage,
      successMessage,
    },
  });
